<template>
  <div id="storyMetadataView">
    <div id="storyMetadataEditor-EditContainer">
      <div class="modal-body">
        <div
          class="wt2-sg"
          :class="{
            storyMetadataEditorLeftSide: bIncludeThumbnailEditor,
            'col-lg-2': !bIncludeThumbnailEditor,
          }"
        >
          <div class="video-info-title wt2-text-l2 wt2-color-normal">
            {{ 'metadataEditor.header' | culture }}
            <span v-if="isStoryboard" class="-storyboard">{{
              'generic.storyboard' | culture
            }}</span>
          </div>
          <p class="row -title wt2-text-field">
            <input
              @keydown="error.title = false"
              type="text"
              class
              v-model="storyCopy.title"
              data-name="title"
              :placeholder="'metadataEditor.titleEmpty' | culture"
            />
            <span v-if="error.title" class="field-error error">{{
              'metadataEditor.errorRequiredField' | culture
            }}</span>
          </p>
          <p class="row -descriptions">
            <textarea
              class="wt2-textarea"
              data-name="description"
              :placeholder="'metadataEditor.descriptionEmpty' | culture"
              v-model="storyCopy.description"
            />
            <!-- <span class="field-error error">{{'metadataEditor.errorDescription' | culture }}</span> -->
          </p>
          <template v-if="storyCopy.storyUrl">
            <p class="row">
              <span data-autotest="original-story-link">
                <a
                  :href="storyCopy.storyUrl"
                  class="word-break-all"
                  data-outside
                  data-bypass
                  title="Opens up in a new window"
                  target="_blank"
                  >Link to Original Story</a
                >
              </span>
            </p>
          </template>
          <p class="row" id="topicsView">
            <topics v-model="storyCopy.keywords" />
          </p>
          <template v-if="isStoryboard">
            <p id="storyboardCategories">
              <storyboard-categories-list
                ref="storyboardCategoriesList"
                @showTopicManager="showTopicManager"
              />
              <span class="-container"></span>
            </p>
          </template>
          <!-- <template v-else>
                                <p class="row">
                                    <span class="title">{{culture 'metadataEditor.category'}}</span>
                                    <span class="select-style">
                                        <select id="mainCategory" >
                                            {{#select this.topicId}}
                                                {{#_categoriesList}}
                                                    <option value="{{id}}">{{label}}</option>
                                                {{/_categoriesList}}
                                            {{/select}}
                                        </select>
                                    </span>
                                    <span class="field-error error">{{culture 'metadataEditor.errorCategory'}}</span>
                                </p>
                                {{#if _manualYoutubeChannelSelection}}
                                    <p class="row">
                                        <span class="title">{{culture 'metadataEditor.youtube'}}</span>
                                        <span class="select-style">
                                            <select id="ddlYoutubeChannel">
                                                <option value="">{{culture 'generic.SELECT'}}</option>
                                                {{#select this.youtubeChannelUID}}
                                                    {{#_wochitYoutubeChannels}}
                                                        <option value="{{value}}">{{label}}</option>
                                                    {{/_wochitYoutubeChannels}}
                                                {{/select}}
                                            </select>
                                        </span>
                                        <span class="field-error error">
                                          {{culture 'metadataEditor.errorRequiredField'}}
                                        </span>
                                    </p>
                                {{/if}}
                                <p class="row">
                                    <span class="title">{{culture 'metadataEditor.attribution'}}</span>
                                    <span class="desc wt2-text-field">
                                      <input type="text" class=""
                                        value="{{this.attributedBy}}" id="inputAttributedBy" data-name="attributedBy"/>
                                    </span>
                                </p>
                                {{#if this.publishedDate}}
                                    <p class="row published-date">
                                        <span class="title">{{culture 'generic.DATE'}}</span>
                                        <span class="date-placeholder">{{printDateTime publishedDate}}</span>
                                    </p>
                                {{/if}}
                            </template>
          </div>-->
        </div>
        <div class="wt-story-metadata-editor-divider"></div>
        <div class="storyMetadataEditorRightSide">
          <template v-if="bIncludeThumbnailEditor">
            <div class="video-poster">
              <div class="wt-additional-info">
                <div
                  class="-box-labeled-data-row"
                  :data-wt-brand-id="storyCopy.brandId"
                  :title="storyBrandName"
                >
                  <span class="-first"
                    >{{ 'metadataEditor.brandLabel' | culture }}:</span
                  >
                  <span class="-second" v-text="storyBrandName" />
                </div>
                <div class="-box-labeled-data-row">
                  <span class="-first">{{
                    'metadataEditor.videoId' | culture
                  }}</span>
                  <span class="-second" v-text="storyCopy.id" />
                </div>
              </div>
              <div id="video-poster-warp">
                <div
                  class="wt-image-container js-image-container js-edit-poster"
                >
                  <img :src="thumbnailUrl" alt id="poster-preview" />
                </div>
                <div class="video-poster-wrap-label" v-if="canAdjustThumbnail">
                  <span class="video-poster-wrap-label-text js-edit-poster">{{
                    'metadataEditor.adjustThumbnail' | culture
                  }}</span>
                  {{ 'metadataEditor.adjustThumbnailOrTake' | culture }}
                </div>
                <div v-else class="video-thumbnail-label">
                  {{ 'metadataEditor.videoThumbnail' | culture }}
                </div>
              </div>
            </div>
          </template>
          <p id="storyboardCategoriesManager" ref="storyboardCategoriesManager">
            <categories-manager
              v-if="categoriesManagerVisible"
              @new="onAddCategory"
              @delete="onDeleteCategory"
              @close="onCloseCategoriesManager"
              :showCloseIcon="true"
            />
          </p>
        </div>
      </div>
      <!-- <div id="storyMetadataEditor-Tumbnail"></div> -->
      <div class="modal-footer">
        <div class="wt2-sg">
          <button
            @click="close"
            type="button"
            class="btn pull-right storyMetadataEditorModelDone done"
          >
            <!-- {{#ifCond displayState 'produce'}}
                                    {{#if isStoryboard}}
                                        {{culture 'generic.ACTION_PRODUCE_SHORT_STORY_TEMPLATE'}}
                                    {{else}}
                                        {{culture 'generic.ACTION_PRODUCE_SHORT'}}
                                    {{/if}}
                                {{else}}
                                    {{culture 'generic.DONE'}}
            {{/ifCond}}-->
            {{ doneBtnText }}
          </button>
        </div>
        <button
          class="btn pull-right storyMetadataEditorModelCancel"
          type="button"
          @click="closeModal()"
        >
          {{ 'generic.CANCEL' | culture }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash-extended';
import Topics from 'v/Topics.vue';
import StoryboardCategoriesList from 'v/metadataEditor/StoryboardCategoriesList.vue';
import CategoriesManager from 'v/CategoriesManager/CategoriesManager.vue';
import { mapGetters } from 'vuex';
import Vue from 'vue';

export default {
  components: {
    Topics,
    StoryboardCategoriesList,
    CategoriesManager,
  },
  props: {
    closeModal: { type: Function, required: false, default: _.noop },
    bIncludeThumbnailEditor: {
      type: Boolean,
      default: true,
    },
    story: {
      type: Object,
      required: true,
    },
    canAdjustThumbnail: {
      type: Boolean,
      default: true,
    },
    doneBtnText: {
      type: String,
      default: app.culture.get('generic.SAVE'),
    },
  },
  data() {
    return {
      storyCopy: {},
      error: {
        title: false,
      },
      categoriesManagerVisible: false,
    };
  },
  computed: {
    ...mapGetters('user', ['selectedOrganization']),

    isStoryboard() {
      return this.story.template;
    },

    thumbnailUrl() {
      return this.story.thumbnailPath
        ? '//' + this.story.thumbnailPath
        : 'https://dp4stoslb9jdl.cloudfront.net/Resources/studio/img/video-poster-placeholder_missing.png';
    },

    storyBrandName() {
      const storyBrand = this.selectedOrganization.brands.find(
        (brand) =>
          brand.brandId === this.story.brandId &&
          brand.programmerId === this.story.programmerId
      );
      return storyBrand ? storyBrand.name : this.story.programmerName;
    },
  },

  mounted() {
    if (this.$refs.storyboardCategoriesList && this.story.categories) {
      this.$refs.storyboardCategoriesList.selectedCategories =
        this.story.categories.reduce(
          (obj, { id }) => ({ ...obj, [id]: true }),
          {}
        );
    }
    this.storyCopy = _.cloneDeep(this.story);
  },
  methods: {
    onCloseCategoriesManager() {
      this.categoriesManagerVisible = false;
      this.$refs.storyboardCategoriesManager.classList.remove('-visible');
      setTimeout(() => {
        this.$refs.storyboardCategoriesManager.classList.remove('-block');
      }, 300);
    },
    onAddCategory({ id }) {
      Vue.set(
        this.$refs.storyboardCategoriesList?.selectedCategories,
        id,
        true
      );
    },
    onDeleteCategory(categoryId) {
      if (this.$refs.storyboardCategoriesList?.selectedCategories?.length) {
        this.$refs.storyboardCategoriesList.selectedCategories =
          this.$refs.storyboardCategoriesList.selectedCategories.filter(
            (category) => category.id !== categoryId
          );
      }
    },
    showTopicManager() {
      this.categoriesManagerVisible = true;
      this.$refs.storyboardCategoriesManager.classList.add('-block');
      setTimeout(() => {
        this.$refs.storyboardCategoriesManager.classList.add('-visible');
      }, 0);
    },
    close() {
      if (_.isEmpty(this.storyCopy.title)) {
        this.error.title = true;
      }
      const categoryIds = Object.entries(
        this.$refs.storyboardCategoriesList.selectedCategories
      )
        .filter((arr) => arr[1])
        .map((arr) => arr[0]);
      if (_.isEmpty(categoryIds)) {
        this.$refs.storyboardCategoriesList.error = true;
      }
      if (
        Object.entries(this.error).reduce(
          (bool, arr) => bool && !arr[1],
          true
        ) &&
        !this.$refs.storyboardCategoriesList.error
      ) {
        this.closeModal({
          ..._.cloneDeep(this.storyCopy),
          categoryIds,
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import 'style_guide/_sg_variables.scss';
@import '_custom_mixins.scss';

#metadataView {
  background-color: $white;

  textarea {
    resize: vertical;
    width: 100%;
  }

  #change-editability.pull-me-up {
    position: relative;
    top: 15px;
    z-index: 1;
  }
  #change-editability.locked {
    cursor: default;
    .op-icon-Locked {
      font-size: 16px;
      vertical-align: middle;
    }
    span {
      vertical-align: middle;
    }
  }

  .narration-time {
    margin-bottom: 10px;
    .op-icon-time {
      position: relative;
      top: -2px;
    }
  }

  .edit-lock {
    input[type='checkbox'] {
      margin-top: -2px;
    }
  }

  .task-container {
    margin-bottom: 0;
  }

  label.done input {
    vertical-align: top;
  }

  .btn-round {
    margin-top: -5px;
    margin-bottom: -5px;
  }

  #topicsView {
    .cell.well.well-small {
      border: 1px solid #cccccc;
      background-color: $white;
      @include border-radius(4px);
      width: 90%;
    }
    #topicsViewPlaceholder {
      margin-bottom: 10px;
      width: 100%;
    }
    label.topic,
    .selectize-control.multi .selectize-input > div.topic {
      //@include topicTag();
      @extend %tag;
      margin: 5px 5px 0 0;
      border: none;
      background-image: none;
      float: left;
      &:hover {
        background-color: darken(#e6e6e6, 15%);
      }
    }
    .selectize-control.multi .selectize-input {
      @include tagSelectizeContainer();
      & > input {
        margin-bottom: 4px !important;
        margin-top: 7px !important;
        float: left;
      }
      .wticon {
        font-size: 10px;
        color: #444444;
        font-style: normal;
        width: 10px;
        display: block;
        height: 22px;
        line-height: 22px;
        float: right;
        margin-left: 5px;
        &:hover {
          color: darken(#444444, 45%);
        }
      }
    }

    .topic.btn-primary {
      box-shadow: 1px 2px 3px #000;
    }
    .topic input[type='checkbox'] {
      visibility: collapse;
      position: absolute;
      margin: 0px;
      padding: 0px;
    }
    .topic i[class^='icon-'] {
      margin-top: 0;
      margin-right: 5px;
    }
    .done {
      white-space: nowrap;
      margin: 3px 0px 0px 12px;
      display: inline-block;
    }
    .done input {
      margin: 0px 6px 1px 0px;
      padding: 0px;
      vertical-align: text-bottom;
    }
    #lblTopicsAlert {
      text-align: center;
      display: block;
      border-radius: 4px;
      padding: 0px 12px;
      margin: 0px auto 8px;
      border: 2px solid #000;
      color: #000;
      width: 432px;
    }
  }

  .excellent-article {
    display: none;
  }

  #title-only {
    margin: 10px 10px 45px 20px;

    .the-title {
      color: $black;
      font-size: 20px;
      font-weight: bold;
      margin: 0 10px 0 0;
    }
    a {
      &[data-action='edit'] {
        font-size: 20px;
        margin: 0px;
      }
      color: $blueHover;
      cursor: pointer;
      font-size: 10px;
      font-weight: bold;
      margin: 3px 10px;

      &[data-outside] {
        font-size: inherit;
        margin: 0;
      }
    }

    span.edit-lock {
      font-size: 12px;
      i {
        font-size: 14px;
        color: $dark-grey;
      }
    }

    #comment-placeholder {
      color: $dark-grey;
      cursor: pointer;
      font-size: 12px;
      margin-right: 10px;

      span {
        display: inline-block;
      }

      i.wt-icon-comment {
        color: $dark-grey;
        font-size: 16px;
        margin: 2px 10px 0 0;
        display: inline-block;
      }

      &.has-comment {
        i.wt-icon-comment {
          color: $blue;
        }
      }
    }
  } //eof #title-only

  #details-wrapper {
    margin: 0 0 20px 20px;
    @extend %metaRow;

    .row-fluid {
      margin: 10px 0 20px;
    }
    span.desc {
      width: calc(100% - 145px);
    }
  }

  #metadata-editor {
    margin: 0 0 20px 20px;
    @extend %metaRow;

    .row-fluid {
      margin: 10px 0 25px;
      &.error {
        margin: 10px 0 -7px;
        span.field-error {
          display: block;
        }
      }

      &.excellent-article {
        input {
          width: auto;
          float: left;
          margin-right: 10px;
        }
      }
    }

    input,
    select,
    textarea {
      margin-bottom: 0;
    }

    input {
      width: 100%;
    }

    span.desc {
      width: calc(100% - 145px);
    }

    span.field-error {
      display: none;
      margin-top: 5px;
      line-height: 14px;
    }
  }

  > .video-poster {
    margin: 10px 10px 10px 0;
    float: right;

    font-size: 11px;
    text-align: center;
    height: 265px;
    background: $grayBorderColor;
    /*border: 1px solid #DFDFDF;
    border-radius: 3px;*/

    h4 {
      color: $black;
      font-size: 16px;
      font-weight: normal;
      height: 40px;
      line-height: 40px;
      margin: 0;
      text-align: center;
    }

    .text {
      color: $black;
      font-size: 14px;
      line-height: 18px;
      text-align: center;
      height: 70px;
      padding: 10px 0;
    }

    #video-poster-warp {
      background: $grayBackground;
      border: 1px solid $grey;

      margin: 5px 5px 0;
      padding: 0 4px;
      position: relative;

      > div {
        overflow: hidden;
        margin: 0 auto 8px;
        width: 96%;
      }

      + div.text {
        display: none;
      }

      &.hasImage {
        + div.text {
          display: block;
        }
      }

      &.hasImage:hover {
        @include transition(500ms all);
        .toolbox {
          height: 25px;
          line-height: 23px;
        }
      }

      .toolbox {
        position: absolute;
        width: 92%;
        bottom: 8px;
        left: 8px;
        background-color: rgba(0, 0, 0, 0.55);
        padding: 0px 4px 0px 4px;
        text-align: center;
        overflow: hidden;
        height: 0px;
        @include transition(500ms height);
        i {
          display: inline-block;
          padding: 0px 4px;
          cursor: pointer;
          font-size: 180%;
          color: #fff;

          &:hover {
            text-shadow: 0px 0px 2px #fff;
          }
        }
      }
    }

    img {
      //height: 135px;
      width: 100%;
      /*max-height: 220px;
      padding: 6px; */
      margin: 0px auto;
      display: block;
    }

    .webpage-wrapper {
      height: 90px;
      overflow: hidden;
      img {
        width: 160px;
        height: auto;
        max-width: none;
        max-height: none;
      }
    }
    .add-webpage-button {
      height: 90px;
      overflow: hidden;
      img {
        width: 160px;
        height: auto;
        max-width: none;
        max-height: none;
      }
    }
  }
}

.wt-region-edit-info {
  height: 100%;
}

.wt-story-metadata-editor {
  color: rgba(0, 0, 0, 0.75);
  cursor: pointer;
  height: 100%;
  display: flex;
  align-items: center;
  width: 143px;

  &.wt-disabled {
    opacity: 0.5;
    cursor: default;
  }

  &:not(.wt-disabled):hover {
    background-color: #f2f2f2;
  }

  .wt-open-editor {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
  }

  .wt-story-title {
    font-size: 16px;
    font-weight: 400;
  }

  .wt-icon-editor {
    font-size: 16px;
    margin-right: 10px;
  }
}

#storyMetadataView {
  @extend #metadataView;
  cursor: default;

  $baseColor: #16c3a6;
  .op-icon-edit-story {
    cursor: pointer;
    margin-left: 10px;
  }

  .modal,
  .modal-center {
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }

  .modal-center {
    display: flex;
    justify-content: center;
    align-items: center;
    overflow-y: auto;
    overflow-x: hidden;
  }

  .wt-close-modal {
    position: absolute;
    right: 20px;
    top: 20px;
    font-size: 20px;
    font-weight: 400;
    cursor: pointer;
    z-index: 5;
    padding: 0;
  }

  #storyMetadataEditor-EditContainer,
  #storyMetadataEditor-Tumbnail {
    position: relative;
    width: 1300px;
    height: 709px;
    background: #fff;
    color: #000;
    -webkit-box-shadow: 2px 5px 23px 14px rgba(0, 0, 0, 0.33);
    -moz-box-shadow: 2px 5px 23px 14px rgba(0, 0, 0, 0.33);
    box-shadow: 2px 5px 23px 14px rgba(0, 0, 0, 0.33);
    overflow: visible;
    padding: 0;
  }
  .video-info-title {
    display: block;
    margin-bottom: 50px;
    padding-left: 20px;
    .-storyboard {
      background: #fdc35d;
      color: #fff;
      margin: 0 0 0 5px;
      padding: 2px 5px;
      font-size: 14px;
      font-weight: 400;
    }
  }
  .modal-body {
    height: 644px;
    padding: 18px 0 0 0;
    display: flex;
    font-size: 14px;
    overflow-y: auto;
    &:before {
      border: 0;
    }
    .video-thumbnail-label {
      padding-top: 10px;
      text-align: center;
      color: $color-grey-2;
    }
    .storyMetadataEditorLeftSide {
      width: 786px;
      p {
        padding-left: 78px;
        &:last-of-type {
          margin-bottom: 10px;
        }
      }

      .row.-title {
        margin-bottom: 40px;

        &.error input {
          border-bottom: 1px solid $errorRed;
        }
      }

      .row.-description {
        margin-bottom: 30px;
      }
    }

    #storyboardCategories {
      padding-left: 78px;
    }
    .wt-story-metadata-editor-divider {
      width: 1px;
      height: 549px;
      background-color: rgba(0, 0, 0, 0.2);
      margin-left: 0;
      margin-top: 62px;
      flex-shrink: 0;
    }
    .storyMetadataEditorRightSide {
      flex-shrink: 0;
      width: 508px;
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;
      overflow-x: hidden;
    }
    div {
      margin-top: 0;
      text-align: left;
    }
    .row {
      margin: 0 0 25px;
    }
    a {
      color: $wt-blue;
      font-size: 13px;
    }
    .title {
      width: 173px;
      display: inline-block;
      float: left;
      padding-top: 5px;
    }
    .desc {
      float: left;
      width: 457px;
      &.text {
        padding-top: 4px;
      }
    }
    ::-webkit-input-placeholder {
      font-size: 14px;
    }
    ::-moz-placeholder {
      font-size: 14px;
    } /* firefox 19+ */
    :-ms-input-placeholder {
      font-size: 14px;
    } /* ie */
    input:-moz-placeholder {
      font-size: 14px;
    }
    textarea,
    input {
      outline: none;
    }

    input {
      border: 0;
      border-bottom: 1px solid $metaDataBordersColor;
      color: $metaDataTextColor;
      box-shadow: 0;
      border-radius: 0;
      font-size: 16px;
      &:focus::-webkit-input-placeholder {
        color: transparent;
      }
      &:focus:-moz-placeholder {
        color: transparent;
      }
      /* FF 4-18 */
      &:focus::-moz-placeholder {
        color: transparent;
      }
      /* FF 19+ */
      &:focus:-ms-input-placeholder {
        color: transparent;
      }
      /* IE 10+ */
    }
    textarea {
      color: $metaDataTextColor;
      font-size: 16px;
      height: 100px;
      padding: 10px;
      @media screen and (max-height: 650px) {
        height: 100px;
      }
      &:focus::-webkit-input-placeholder {
        color: transparent;
      }
      &:focus:-moz-placeholder {
        color: transparent;
      }
      /* FF 4-18 */
      &:focus::-moz-placeholder {
        color: transparent;
      }
      /* FF 19+ */
      &:focus:-ms-input-placeholder {
        color: transparent;
      }
      /* IE 10+ */
    }
    select {
      border: 1px solid $metaDataBordersColor;
      border-radius: 0;
      width: 158px;
    }
    .select-style {
      &:after {
        content: '';
        border-top: 5px solid $metaDataBordersColor;
        border-right: 5px solid transparent;
        border-left: 5px solid transparent;
        border-bottom: 5px solid transparent;
      }
    }

    .date-placeholder {
      select {
        width: 100%;
        height: 100%;
        appearance: none;
        background: $white;
        margin: 0 auto;
        display: block;
        -webkit-appearance: none;
        // text-indent: 16px;
        &:focus {
          outline: 0;
        }
      }

      .wt-checkbox {
        float: right;
        margin-top: 4px;
      }

      .timeWrap {
        border: 1px solid rgba(89, 89, 89, 0.6);
        height: 32px;
        display: inline-block;
        padding: 0;
        font-size: 12px;
        vertical-align: top;
        width: 57px;
        margin-right: 3px;
        position: relative;
        &:after {
          content: '◀▶';
          color: #898a8a;
          -webkit-transform: rotate(90deg);
          -moz-transform: rotate(90deg);
          -ms-transform: rotate(90deg);
          transform: rotate(90deg);
          right: 3px;
          font-size: 7px;
          top: 10px;
          padding: 0 0 2px;
          /* border-bottom: 1px solid #ddd; */
          position: absolute;
          pointer-events: none;
          letter-spacing: 2px;
        }
      }
    }
    .date-part {
      border: 1px solid rgba(89, 89, 89, 0.6);
      text-align: center;
      width: 108px;
      height: 32px;
      font-size: 12px;
      margin: 0 5px 0 0;
      color: #000000;
    }
    .wt-checkbox {
      float: left;
      width: 148px;
      label {
        font-weight: 300;
        font-size: 14px;
        left: 6px;
        padding: 0;
      }
      span {
        &:after {
          top: 12px;
          left: -29px;
        }
      }
    }
    .wt-auto-transition {
      margin-top: 472px;
      display: flex;
      align-items: center;
      position: relative;

      &.-disabled {
        .wt-auto-transition-toggle {
          pointer-events: none;
          opacity: 0.3;
        }
      }

      .wt-auto-transition-toggle {
        margin-left: 30px;
        @include checkBoxSlide(
          26px,
          12px,
          '',
          '',
          'wochit',
          #3f4857,
          #fffffd,
          '',
          #16e2b8,
          #fffffd,
          ''
        );

        label {
          &:after {
            box-shadow: 0 2px 4px rgba(0, 0, 0, 0.37);
          }
        }
      }

      .wt-auto-transition-text {
        color: #4a4a4a;
        font-size: 14px;
        font-weight: 300;
      }

      .wticon-information1 {
        color: #4a4a4a;
        font-size: 18px;
        margin-left: 15px;
      }

      .tooltip {
        margin-left: -110px;
        margin-top: -3px;

        .tooltip-arrow {
          left: 256px !important;
        }

        .tooltip-inner {
          width: 294px;
          max-width: 294px;
          box-shadow: 1px 1px 5px #363e44;
          border-radius: 6px;
          background-color: #48525e;
          font-size: 15px;
          font-weight: 300;
        }
      }
    }
  }
  .modal-footer {
    background: #fff;
    height: 65px;
    position: relative;
    display: flex;
    align-items: flex-end;
    flex-direction: row-reverse;
    justify-content: flex-start;
    border: 0;
    padding: 0;
    > :not(:last-child) {
      margin-right: 0;
    }
  }
  .modal-header h3 {
    text-overflow: ellipsis;
    overflow: hidden;
    max-width: 700px;
    max-height: 17px;
  }
  textarea {
    height: 95px;
    margin: 0;
  }
  textarea.small-narratedText {
    height: 60px;
  }
  .selectize-input {
    max-height: 60px;
    overflow-y: auto;
    outline: none;
    border: 0;
    border-bottom: 1px solid $metaDataBordersColor;
    box-shadow: none;
    border-radius: 0;
  }
  #title-only {
    margin-bottom: 10px;
  }
  input[type='text'] {
    width: 100%;
  }
  .video-poster {
    height: 100%;
    position: relative;
    display: flex;
    align-items: center;
    .text {
      text-align: center;
    }
    .video-poster-wrap-explain {
      width: 100%;
      bottom: 0;
      height: 20px;
    }
    .wt-additional-info {
      display: flex;
      border: 1px solid rgba(0, 0, 0, 0.2);
      height: 90px;
      flex-direction: column;
      width: 348px;
      top: 62px;
      justify-content: space-evenly;

      .-box-labeled-data-row {
        display: flex;
        span {
          color: #000000;
          font-size: 14px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;

          &.-first {
            width: 40%;
            padding-left: 15px;
            font-weight: 300;
          }

          &.-second {
            max-width: 55%;
            font-weight: 400;
          }
        }
      }
    }
  }

  .wt-image-container {
    width: 348px;
    height: 196px;
    overflow: hidden;
    cursor: default;
    &.-disabled {
      cursor: default;
    }

    img {
      width: 100%;
    }
  }
  #video-poster-warp {
    width: 348px;
    height: 196px;
    border-radius: 2px;
    -webkit-box-shadow: 2px 2px 2px rgba(0, 0, 0, 0.2);
    -moz-box-shadow: 2px 2px 2px rgba(0, 0, 0, 0.2);
    box-shadow: 2px 2px 2px rgba(0, 0, 0, 0.2);
    top: 199px;
    left: 77px;

    .video-poster-wrap-label {
      font-size: 14px;
      position: absolute;
      bottom: -33px;
      left: 50%;
      transform: translate(-50%);
      font-weight: 400;
      width: 100%;
      text-align: center;
      color: $color-normal;

      span {
        color: $color-primary;
        cursor: pointer;

        &.-disabled {
          cursor: default;
          color: rgba(0, 0, 0, 0.3);
        }
      }

      i {
        display: inline-block;
        position: relative;
        bottom: 0;
        left: 3px;
      }
    }
    &.hasImage div {
      overflow: hidden;
      display: inline-block;
    }
    .row {
      position: relative;
      text-align: center;
      margin: 0;
      img {
        max-width: 225px;
        border-radius: 2px;
        -webkit-box-shadow: 2px 9px 26px -4px rgba(0, 0, 0, 0.15);
        -moz-box-shadow: 2px 9px 26px -4px rgba(0, 0, 0, 0.15);
        box-shadow: 2px 9px 26px -4px rgba(0, 0, 0, 0.15);
      }
    }
  }
  #storyMetadataEditor-Tumbnail {
    display: none;
  }
  #thumbnailPickerView {
    left: 50%;
    top: inherit;
    height: 100%;
    transform: none;
    margin: inherit;
    -webkit-box-shadow: 1px 0px 10px rgba(0, 0, 0, 0.46);
    -moz-box-shadow: 1px 0px 10px rgba(0, 0, 0, 0.46);
    box-shadow: 1px 0px 10px rgba(0, 0, 0, 0.46);

    @media screen and (max-height: 750px) {
      .right {
        overflow-y: auto;
      }
      .list {
        max-height: 100%;
      }
    }
  }
  #storyMetadataEditorTitleEdit {
    cursor: pointer;
  }
  .line-error {
    display: none;
  }
  button {
    text-align: center;
    background-color: transparent;
    height: 50px;
    border-radius: 0;
    border: none;
    font-size: 16px;
    color: #000000;
    font-weight: 400;
    min-width: 120px;
    width: unset;
    line-height: 40px;
    padding: 0 20px;

    &.done {
      background-color: #06a9f4;
      color: $white;
      &:not([disabled]):hover {
        background-color: darken(#06a9f4, 15);
      }
    }
    &.storyMetadataEditorModelCancel {
      min-width: unset;
      &:not([disabled]):hover {
        background-color: #f2f2f2;
      }
      &:active {
        box-shadow: none;
      }
    }
    &[disabled] {
      background: $disabled-gray;
      color: $weak-grey;
      cursor: default;
    }
  }

  .field-error {
    color: $errorRed;
    display: block;
    padding-top: 2px;
  }
}

#storyMetadataEditor-AreYouSure {
  width: 500px;
  height: 200px;
}
</style>
